var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcJumpForward(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 7.138 13.686"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_64",
    "data-name": "Group 64",
    transform: "rotate(180 445.069 565.922)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_99",
    d: "M2203.7 1029.964l-6.856 6.111-6.83-6.111z",
    className: "cls-1",
    "data-name": "Path 99",
    transform: "rotate(90 1495.978 424.123)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_31",
    d: "M0 0v13",
    className: "cls-2",
    "data-name": "Line 31",
    transform: "translate(883.5 1118.5)"
  }))));
}
export default __webpack_public_path__ + "static/media/ic_jump_forward.89559653.svg";
export { SvgIcJumpForward as ReactComponent };